import { formatDate } from './dateUtils';

/**
 * A calendar date as YYYY-MM-DD (how loaded rows hold ASOFDT), read from the
 * string's own digits when it is YYYY-MM-DD[...] or M/D/YY[YY] (how Excel
 * writes "Pricing Received" dates, e.g. 8/31/26), so the local timezone cannot
 * shift the day. Any other format goes through formatDate. '' when it is not a
 * real date. Two-digit years read as Excel and Date read them: 00-49 -> 20xx,
 * 50-99 -> 19xx.
 * @param {string|Date} value
 * @returns {string}
 */
export const toCalendarDate = (value) => {
  const text = value instanceof Date ? formatDate(value) : String(value ?? '').trim();
  if (!text) return '';
  const iso = text.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
  const us = iso ? null : text.match(/^(\d{1,2})\/(\d{1,2})\/(\d{2}|\d{4})$/);
  const other = iso || us ? null : String(formatDate(text) ?? '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
  let parts;
  if (iso || other) {
    const [, y, m, d] = iso || other;
    parts = [y, m, d];
  } else if (us) {
    const [, m, d, y] = us;
    parts = [y.length === 2 ? Number(y) + (Number(y) < 50 ? 2000 : 1900) : y, m, d];
  } else {
    return '';
  }
  const [year, month, day] = parts.map(Number);
  const date = new Date(Date.UTC(year, month - 1, day));
  if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) return '';
  return `${String(year).padStart(4, '0')}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
};
